import React from 'react';
export function CompletedIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M15 2H2v20h20v-7h-2v5H4V4h11V2z"
  }), React.createElement("path", {
    d: "M10.5 17.914L22.707 5.707l-1.414-1.414L10.5 15.086l-3.293-3.293-1.414 1.414 4.707 4.707z"
  }));
}